import './utils/touch-fix';
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// Toast
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { toastConfig } from './plugins/notifications'

import App from './App.vue'
import router from './router'
import { vuetify } from './plugins/vuetify'
import VueTheMask from 'vue-the-mask'
import { QuillEditor } from '@vueup/vue-quill'
import { EmailEditor } from 'vue-email-editor';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

// import picker compopnent
import EmojiPicker from 'vue3-emoji-picker'
// import css
import 'vue3-emoji-picker/css'

// import apexcharts
import VueApexCharts from "vue3-apexcharts";

import trimInput from './directives/trim-input'
import onlyNumbers from './directives/only-numbers'
import uppercase from './directives/uppercase'
import lowercase from './directives/lowercase'
import softDisable from './directives/soft-disable'
import copyToClipboard from './directives/copy-to-clipboard';
import bankAccountFormat from './directives/bank-account-format';

import ResponsiveDataTable from '@/components/ResponsiveDataTable.vue';

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(vuetify)
app.use(Toast, toastConfig)
app.use(VueTheMask)
app.use(VueApexCharts)
app.directive('v-mask', VueTheMask)
app.directive('trim-input', trimInput);
app.directive('only-numbers', onlyNumbers);
app.directive('uppercase', uppercase);
app.directive('lowercase', lowercase);
app.directive('soft-disabled', softDisable);
app.directive('copy-to-clipboard', copyToClipboard);
app.directive('bank-account-format', bankAccountFormat);
app.component('ResponsiveDataTable', ResponsiveDataTable);
app.component('QuillEditor', QuillEditor);
app.component('EmailEditor', EmailEditor);
app.component('EmojiPicker', EmojiPicker);
// eslint-disable-next-line vue/multi-word-component-names
app.component('apexchart', VueApexCharts)

app.mount('#app')
